<form id="onboarding-context-form" class="onboarding-context-form" [formGroup]="form" (ngSubmit)="save()">
	@if (errorMessage()) {
		<div class="alert alert-danger onboarding-context-error" role="alert">{{ errorMessage() }}</div>
	}

	<!-- ROLE -->
	<div class="form-group required onboarding-context-question">
		<label class="control-label onboarding-context-multi-label">What is your role?</label>
		<div class="onboarding-context-checkbox-grid onboarding-context-roles">
			@for (column of roleColumns; track $index) {
				<div class="onboarding-context-checkbox-column">
					@for (option of column; track option) {
						<label class="checkbox-label onboarding-context-checkbox-option">
							<input
								type="checkbox"
								class="onboarding-context-role-option"
								[checked]="isRoleSelected(option)"
								(change)="toggleRole(option)"
							/>
							{{ option }}
						</label>
					}
				</div>
			}
		</div>
		@if (showFieldError(form.controls.roles)) {
			<div class="invalid-feedback d-block onboarding-context-role-error">Please select at least one option.</div>
		}
		@if (showRoleOther()) {
			<input
				type="text"
				class="form-control onboarding-context-follow-up onboarding-context-role-other"
				formControlName="roleOther"
				placeholder="Please specify"
				maxlength="255"
				[class.is-invalid]="showFieldError(form.controls.roleOther)"
			/>
		}
	</div>

	<!-- HELP -->
	<div class="form-group required onboarding-context-question">
		<label class="control-label onboarding-context-multi-label">How can we help you?</label>
		<div class="onboarding-context-checkbox-grid onboarding-context-intents">
			@for (column of intentColumns; track $index) {
				<div class="onboarding-context-checkbox-column">
					@for (option of column; track option) {
						@if (option === allOfTheAboveOption) {
							<label class="checkbox-label onboarding-context-checkbox-option">
								<input
									type="checkbox"
									class="onboarding-context-intent-all"
									[checked]="isAllIntentsSelected()"
									(change)="toggleAllIntents()"
								/>
								{{ allOfTheAboveOption }}
							</label>
						} @else {
							<label class="checkbox-label onboarding-context-checkbox-option">
								<input
									type="checkbox"
									class="onboarding-context-intent-option"
									[checked]="isIntentSelected(option)"
									(change)="toggleIntent(option)"
								/>
								{{ option }}
							</label>
						}
					}
				</div>
			}
		</div>
		@if (showFieldError(form.controls.intents)) {
			<div class="invalid-feedback d-block onboarding-context-intent-error">Please select at least one option.</div>
		}
		@if (showIntentOther()) {
			<input
				type="text"
				class="form-control onboarding-context-follow-up onboarding-context-intent-other"
				formControlName="intentOther"
				placeholder="Please let us know how we can help..."
				maxlength="255"
				[class.is-invalid]="showFieldError(form.controls.intentOther)"
			/>
		}
	</div>

	<!-- COMPANY COUNT -->
	<div class="form-group required onboarding-context-question">
		<label class="control-label onboarding-context-multi-label">How many companies do you manage?</label>
		<select
			class="form-control onboarding-context-company-count"
			formControlName="companyCount"
			[class.is-invalid]="showFieldError(form.controls.companyCount)"
			[class.placeholder]="!form.controls.companyCount.value"
		>
			<option value="" disabled>Please select no. of companies</option>
			@for (option of companyCountOptions; track option) {
				<option [value]="option">{{ option }}</option>
			}
		</select>
	</div>

	@if (showTrustCount()) {
		<div class="form-group required onboarding-context-question">
			<label class="control-label onboarding-context-multi-label">How many trusts do you manage?</label>
			<select
				class="form-control onboarding-context-trust-count"
				formControlName="trustCount"
				[class.is-invalid]="showFieldError(form.controls.trustCount)"
				[class.placeholder]="!form.controls.trustCount.value"
			>
				<option value="" disabled>Please select no. of trusts</option>
				@for (option of trustCountOptions; track option) {
					<option [value]="option">{{ option }}</option>
				}
			</select>
		</div>
	}

	<!-- HEAR -->
	<div class="form-group required onboarding-context-question">
		<label class="control-label onboarding-context-multi-label">Where did you hear about us?</label>
		<select
			class="form-control onboarding-context-hear"
			formControlName="hear"
			[class.is-invalid]="showFieldError(form.controls.hear)"
			[class.placeholder]="!form.controls.hear.value"
		>
			<option value="" disabled>Please select</option>
			@for (option of hearOptions; track option) {
				<option [value]="option">{{ option }}</option>
			}
		</select>
		@if (showReferral()) {
			<input
				type="text"
				class="form-control onboarding-context-follow-up onboarding-context-referral"
				formControlName="hearReferral"
				placeholder="Who referred you? We'd love to thank them 🎁"
				maxlength="255"
				[class.is-invalid]="showFieldError(form.controls.hearReferral)"
			/>
		}
		@if (showHearOther()) {
			<input
				type="text"
				class="form-control onboarding-context-follow-up onboarding-context-hear-other"
				formControlName="hearOther"
				placeholder="Please specify"
				maxlength="255"
				[class.is-invalid]="showFieldError(form.controls.hearOther)"
			/>
		}
	</div>
</form>
